import { AutoMap } from "@automapper/classes";
import { OperatorDTO } from "./operator.dto";
import { ProcessSamplingConditionDTO } from "./process-sampling-condition.dto";
import { SecuriteDTO } from "./securite.dto";
;

export class ProcessMeasureDTO {
    @AutoMap()
    code!: string;
    @AutoMap()
    isCancelled!: boolean;
    @AutoMap()
    measureReferenceCode!: string;
    @AutoMap()
    measureReferenceName!: string;
    @AutoMap()
    status!: number;
    @AutoMap()
    localisation!: string;
    @AutoMap()
    textColor!: string;
    @AutoMap()
    color!: string;
    // @AutoMap()
    // SamplingID: number;
    @AutoMap()
    observation?: string;
    @AutoMap()
    processSamplingCondition!: ProcessSamplingConditionDTO;
    @AutoMap(() => [OperatorDTO])
    processOperatorList: OperatorDTO[] = [];
    @AutoMap()
    securite!: SecuriteDTO;

}